import { BrowserRouter, useRoutes } from "react-router-dom";
import routes from "routes";

import { Auth0Provider } from "@auth0/auth0-react";
import { QueryClient, QueryClientProvider } from "react-query";

/*import reportWebVitals from './reportWebVitals';*/

import "app.css";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  },
});
const AppRoutes = () => useRoutes(routes);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        redirectUri={window.location.origin}
      >
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </Auth0Provider>
    </QueryClientProvider>
  );
}
